export default __webpack_public_path__ + "static/anticipamos-323d9014fee62e1550833f0c11ca631a.png";